import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbAssetsReportsTemplateRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbAssetsReportsTemplateRoute.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { AssetsReports, LazyServicedeskCmdbAssetsReports } from './ui/reports/index.tsx';

import { AssetsAppRedirect } from './ui/redirect/assets-app-redirect/index.tsx';

export const servicedeskCmdbAssetsReportsTemplateRouteEntry: Route = createEntry(
	servicedeskCmdbAssetsReportsTemplateRoute,

	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_as_an_app_v2') ? AssetsAppRedirect : AssetsReports,

		resources: [
			...getNavigationResources(),
			...getServicedeskPageContextResources(),
			workspaceResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskCmdbAssetsReports],

		navigation: {
			menuId: MenuIdPeople,
		},

		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_ASSETS_REPORTS,
				packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_REPORTS),
				teamName: 'ITSM SAGA',
			},
		},

		perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
